import React from "react";

// DS
import { Avatar } from "@toddle-edu/ds-web";
import {
  GraduationCapOutlined,
  OpenBookOutlined,
  ReportGearOutlined,
  ProgressReportOutlined,
} from "@toddle-edu/ds-icons";

// Transcript Permissions
import {
  TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
  TRANSCRIPT_CAN_MANAGE_TEMPLATES_PERMISSION,
  TRANSCRIPT_CAN_MANAGE_TRANSCRIPT_DOWNLOAD_PERMISSION,
} from "Constants/permissionConstants";

export const DATA_GRID_DROPDOWN_HEIGHT = 192;

export const DATA_GRID_CELL_TYPES = {
  TEXT: "text",
  CHECKBOX: "checkbox",
};

export const DATA_GRID_CHECKBOX_STATES = {
  CHECKED: "checked",
  UNCHECKED: "unchecked",
};

export const TRANSCRIPTS_PERMISSION_TYPES = {
  ACCOUNT: "account",
  SCHOOL: "school",
};

export const CHECKLIST_DATA = t => [
  {
    id: "PREPARE_DATA_HEADING",
    label: t("transcript:prepare_transcript_data"),
    children: [
      {
        id: "GRADING_PERIOD_SETUP",
        icon: (
          <Avatar
            iconType="icon"
            icon={<GraduationCapOutlined />}
            size="medium"
            color="blue"
            shape="square"
          />
        ),
        label: t("transcript:set_transcript_grading_periods"),
        subtext: t("transcript:grading_periods_card_subtext"),
        labelForHeader: t("common:configure_label", {
          label: t("common:grading_period_plural"),
        }),
        subtextForHeader: t("common:transcripts"),
        route: "grading-periods",
        permission: {
          type: TRANSCRIPTS_PERMISSION_TYPES.SCHOOL,
          value: TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
        },
      },
      {
        id: "VERIFY_STUDENT_RECORDS",
        icon: (
          <Avatar
            iconType="icon"
            icon={<OpenBookOutlined />}
            size="medium"
            color="green"
            shape="square"
          />
        ),
        label: t("transcript:verify_student_records"),
        subtext: t("transcript:verify_student_records_subtext"),
        route: "prepare-data",
        showPageHeader: false,
        permission: {
          type: TRANSCRIPTS_PERMISSION_TYPES.SCHOOL,
          value: TRANSCRIPT_CAN_MANAGE_ACADEMIC_RECORDS_PERMISSION,
        },
      },
    ],
  },
  {
    id: "TRANSCRIPT_GENERATION",
    label: t("transcript:transcript_generation"),
    children: [
      {
        id: "CONFIGURE_TRANSCRIPT_TEMPLATE",
        icon: (
          <Avatar
            iconType="icon"
            icon={<ReportGearOutlined />}
            size="medium"
            color="purple"
            shape="square"
          />
        ),
        label: t("transcript:checklist_configure_template_label"),
        subtext: t("transcript:configure_transcript_template_subtext"),
        labelForHeader: t("transcript:transcript_templates"),
        route: "configure-templates",
        permission: {
          type: TRANSCRIPTS_PERMISSION_TYPES.ACCOUNT,
          value: TRANSCRIPT_CAN_MANAGE_TEMPLATES_PERMISSION,
        },
      },
      {
        id: "DOWNLOAD_STUDENT_TRANSCRIPTS",
        icon: (
          <Avatar
            iconType="icon"
            icon={<ProgressReportOutlined />}
            size="medium"
            color="orange"
            shape="square"
          />
        ),
        label: t("transcript:download_student_transcripts"),
        subtext: t("transcript:download_student_transcripts_subtext"),
        route: "generate-transcripts",
        showPageHeader: false,
        permission: {
          type: TRANSCRIPTS_PERMISSION_TYPES.SCHOOL,
          value: TRANSCRIPT_CAN_MANAGE_TRANSCRIPT_DOWNLOAD_PERMISSION,
        },
      },
    ],
  },
];
